export default __webpack_public_path__ + "static/media/github.008e0d50.svg";